import React from 'react';
import InteractiveWorkflow from '../components/Dashboard/InteractiveWorkflow';
import { useAuth } from '../context/AuthContext';
import { Target, Activity, Layout, Home } from 'lucide-react';

const Portal = () => {
    const { user } = useAuth();

    return (
        <div className="page-enter p-8 lg:p-12 max-w-[1600px] mx-auto min-h-screen flex flex-col justify-center animate-in fade-in zoom-in duration-1000">
            <header className="mb-12 text-center">
                <div className="inline-flex items-center gap-3 glass px-6 py-2 rounded-full border-white/10 mb-6 shadow-xl shadow-primary/20">
                    <Target size={14} className="text-primary-light animate-pulse" />
                    <span className="text-[10px] font-black uppercase tracking-[3px] text-white/50">Sala de Comando Operacional</span>
                </div>
                <h1 className="text-5xl lg:text-7xl font-black text-white tracking-tighter">
                    Mapa de <span className="text-primary-light italic font-medium">Flujo Perceptual</span>
                </h1>
                <p className="text-white/30 mt-6 text-lg max-w-2xl mx-auto font-medium leading-relaxed">
                    Navega por la infraestructura de <strong className="text-white">PawSpa Pro</strong> a través de su flujo interactivo. Toca las zonas activas para saltar a los módulos.
                </p>
            </header>

            <div className="relative group p-10 rounded-[50px] bg-slate-950/40 border border-white/5 shadow-inner backdrop-blur-3xl overflow-hidden">
                {/* Efectos de Iluminación Ambientales */}
                <div className="absolute -top-40 -left-40 w-96 h-96 bg-primary/20 rounded-full blur-[150px] animate-pulse"></div>
                <div className="absolute -bottom-40 -right-40 w-96 h-96 bg-secondary/20 rounded-full blur-[150px] animate-pulse delay-1000"></div>

                <div className="relative z-10">
                    <InteractiveWorkflow />
                </div>
            </div>

            <footer className="mt-12 flex justify-center gap-8 items-center text-white/20 select-none">
                <div className="flex items-center gap-2 text-[10px] font-black uppercase tracking-widest">
                    <Activity size={14} /> Sistema Optimizado
                </div>
                <div className="w-1.5 h-1.5 rounded-full bg-white/10"></div>
                <div className="flex items-center gap-2 text-[10px] font-black uppercase tracking-widest">
                    <Layout size={14} /> Interfaz Visual V3
                </div>
                <div className="w-1.5 h-1.5 rounded-full bg-white/10"></div>
                <div className="flex items-center gap-2 text-[10px] font-black uppercase tracking-widest">
                    <Home size={14} /> Estación de {user?.nombre || 'Administrador'}
                </div>
            </footer>
        </div>
    );
};

export default Portal;
